// An highlighted block
<template>
  <div>
    <el-button :size="size" :icon="icon" :type="type" :plain="plain" :round="round" 
        @click="editingVisible=true"
        :readonly="readonly" :disabled="disabled" >{{ btnText }}<i :class="iclass"></i></el-button>
    <l-dialog 
        :title="title" 
        :visible.sync="editingVisible" 
        :height="628" 
        :width="1000" 
        v-el-drag-dialog
        @ok="handleCodeSave" 
        @opened="handleOpenedForm"
        @close="handleCloseForm">
        <l-code-editor-panel 
            ref="editor" 
            :readonly="readonly" 
            :disabled="disabled" 
            v-model="editingCode"
            :mode="mode"
            :CodeDescription="CodeDescription"
            :theme="theme"
            :Hints="Hints"
            :category="category"
            :method="method"
            :params="params"
            :onHinting="onHinting"
            >
        </l-code-editor-panel>
    </l-dialog>
  </div>
</template>
<script>

//{required: true, message: this.$t('车号是必填项')},
//{validator: this.validateCarNum, message: '车牌号格式不正确'}
export default {
  description: '代码编辑',
  name: 'l-code-editor-button',
  props: {
    value: {},
    size:{
        type: String,
        default: 'mini'
    },
    type:{
        type: String,
        default: 'primary'
    },
    plain:String,
    round:String,
    circle:String,
    icon:String,
    iclass:String,
    btnText: String,
    readonly: Boolean,
    disabled: Boolean,
    title: {
            type:String,
            default: '代码编辑'
        }, 
    category:{
            type:String,
            default: 'formEvent'
        },
    method:{
            type:String,
            default: 'CallFunction'
        },
    params:{
            type:String,
            default: ''
        }, 
        mode: {
            type:String,
            default: 'text/x-csharp'
        },
        CodeDescription:{
            type: String,
            default: ''
        },
        Hints: {
            type: Array,
            default: () => []
        },
        theme:{
            type:String,
            default: 'default'
        },
    onHinting: {  // 数据缺失时的回调
            type: Function,
            default: null
        },
  },
  data() {
    return {
        editingVisible: false,
        editingCode: '',
    }
  },
  computed:{
    value2:{
        get(){
            return this.value;
        },
        set(val){
            this.$emit('input', val)
            this.$emit('change', val)
        }
    }
  },
  methods: {
    handleClick(){
        this.editingVisible = true;
    },
    handleOpenedForm() {
        this.editingCode = this.value2        
    },
    handleCloseForm(){
    },
    handleCodeSave(){
        this.$refs.editor.validate( res=>{
            if(res){
                this.value2 = this.editingCode
                this.editingVisible = false;
            }
        })
    }
  }
}
</script>

